import { Component, Input } from '@angular/core';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import {Bom, ProcessSheets, TId} from 'src/app/models';

@Component({
    selector: 'app-process-sheets-bom-add',
    templateUrl: './process-sheets-bom-add.component.html',
    styleUrl: './process-sheets-bom-add.component.sass',
    standalone: false
})
export class ProcessSheetsBomAddComponent extends GenericCrudAddComponent<Bom> {

   @Input() processSheet?: ProcessSheets;
   override resource = this.api.resources.product.boms;

  initFormGroup() {
    return this.fb.group({
      code: [this.processSheet?.code],
      name: [this.processSheet?.name],
      documentTypeId: [this.processSheet?.documentTypeId],
      companyId: [this.api.auth.userValue?.lastCompanyId],
    });
  }

  override onInitExtendActions(): void {
    setTimeout(() => this.form!.markAsDirty(), 0);
  }

}
